import { DefaultButton, FontIcon, Panel, PanelType, PrimaryButton, TextField } from '@fluentui/react';
import React, { useCallback, useEffect, useState } from 'react'
import IdicadorProgress from '../../../components/generic/IndicadorProgress';
import { MensajeBar } from '../../../components/generic/ManejoResponseMessage/MessageBar';
import { useBoolean } from "@fluentui/react-hooks";
import TipoEquipoService from '../../../services/ListaVerificacion/TipoEquipoService';
import { IActualizarTipoEquipo } from '../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo';
import { IResponsePost } from '../../../Interfaces/base/IResponse';
import { PanelHeader } from '../../../components/Panel/PanelHeader';

export const PanelActualizarTipoEquipo = (props: any) => {


    const [response, setResponse] = useState<IResponsePost>(null!);
    const [isSend, { setTrue: onEnviar, setFalse: onCancelar }] =
        useBoolean(false);

    const [tipoEquipo, setTipoEquipo] =
        useState<IActualizarTipoEquipo>({
            TipoEquipoId: "",
            Nombre: ""
        });

    const [newNombre, setNewNombre] = useState("");

    const [disableBtn, setDisableBtn] = useState(true);

    const onChangeTextField = (
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string,
        TipoEquipoId?: string
    ) => {
        if (event !== undefined) {
            if (newValue !== undefined) {
                if (TipoEquipoId) {
                    // setTipoEquipo((prev) => ({
                    //     ...prev,
                    //     Nombre: newValue,
                    // }));
                    // setTipoEquipo({
                    //     TipoEquipoId: TipoEquipoId,
                    //     Nombre: newValue,
                    // });
                    if (tipoEquipo.Nombre != newValue) {
                        setDisableBtn(false)
                    }
                    else {
                        setDisableBtn(true)
                    }
                    setNewNombre(newValue)
                }
            }
        }
    };

    const actualizarTipoEquipo = () => {
        ocultarMensaje();
        onEnviar();
        const actualizarTipoEquipo: IActualizarTipoEquipo = { ...tipoEquipo }
        // actualizarTipoEquipo.TipoEquipoId = "newNombre"
        actualizarTipoEquipo.Nombre = newNombre
        TipoEquipoService.TipoEquipoActualizar(actualizarTipoEquipo)
            .then((res) => {
                if (res.status === 200) {
                    setResponse({
                        codigoMensaje: 1,
                        mensaje: "Actualización realizada",
                    });
                    onCancelar();
                    //loadTabla()
                    props.onRefreshTable();
                }
                else {
                    setResponse({
                        codigoMensaje: 3,
                        mensaje: "Actualización no realizada",
                    });
                }
                onCancelar();
            })
            .catch((err) => {
                setResponse({
                    codigoMensaje: 3,
                    mensaje: "Error al realizar la actualización",
                });
                onCancelar();
            });
    };

    const ocultarMensaje = () => {
        setResponse(null!);
    };


    const onRenderFooterPanel = useCallback(
        () => (
            <>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        justifyItems: "center",
                        height: "5%",
                        padding: "2opx",
                        margin: "20px",
                    }}
                >
                    <div style={{ display: "flex" }}>
                        <PrimaryButton disabled={disableBtn} onClick={() => actualizarTipoEquipo()} text="Guardar" />
                    </div>
                    <div style={{ display: "flex" }}>
                        <DefaultButton
                            onClick={() => {
                                props.onDismiss();
                            }}
                            text={"Salir"}
                        />
                    </div>
                </div>
            </>
        ),
        [props.onDismiss, actualizarTipoEquipo, disableBtn]
    );
    const onRenderHeaderPanel = useCallback(
        () => (
            <>
                <PanelHeader
                    key={"editar"}
                    nameIconHeader="Edit"
                    subTextHeader="Editar el Nombre del Tipo de Equipo"
                    textHeader="Tipo de Equipo"
                />
            </>
        ),
        []
    );



    useEffect(() => {
        if (props.isOpen) {
            setTipoEquipo(props.modelActualizarEquipoTipo);
            setNewNombre(props.modelActualizarEquipoTipo?.Nombre || "");
            setDisableBtn(true);
        }
    }, [props.isOpen, props.modelActualizarEquipoTipo]);

    useEffect(() => {
        if (!props.isOpen) {
            ocultarMensaje();
        }
    }, [props.isOpen]);


    return (
        <>

            <Panel
                isOpen={props.isOpen}
                onDismiss={props.onDismiss}
                isFooterAtBottom={true}
                onRenderHeader={onRenderHeaderPanel}
                onRenderFooter={onRenderFooterPanel}
                closeButtonAriaLabel="Close"
                type={PanelType.smallFixedFar}
                isLightDismiss
            >
                {/* <pre>{JSON.stringify("--------exsisteEquipo---", null, 2)}</pre>
                <pre>{JSON.stringify(tipoEquipo, null, 2)}</pre>
                <pre>{JSON.stringify(newNombre, null, 2)}</pre> */}
                <MensajeBar
                    response={response}
                    ocultar={() => {
                        ocultarMensaje();
                    }}
                />

                {isSend === true ? (
                    <>
                        <IdicadorProgress
                            isSend={isSend}
                            subText="Espere un momento..."
                        />
                    </>
                ) : (
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-lg12">
                            <br />
                            <TextField
                                label="Nombre Tipo de Equipos:"
                                value={newNombre}
                                onChange={(e, value) =>
                                    onChangeTextField(e, value, props.modelActualizarEquipoTipo?.TipoEquipoId)
                                }
                                onRenderPrefix={(arg) => (
                                    <FontIcon
                                        iconName="Rename"
                                    //style={{ color: COLORES.Bases.primary }}
                                    />
                                )}
                                placeholder="Nombre de Tipo Equipos *"
                            />
                        </div>
                    </div>
                )}
            </Panel>
        </>
    )
}
